import { apiClient } from "./client";

// HR Policies (HR Center tab + the employee's profile card). ⚠️ Return `res.data`.
export async function fetchHrPolicies() {
  return (await apiClient("get", "/hr/policies")).data;
}

export async function fetchHrPolicy(id) {
  return (await apiClient("get", `/hr/policies/${id}`)).data;
}

export async function createHrPolicy(name) {
  return (await apiClient("post", "/hr/policies", { name })).data;
}

export async function updateHrPolicy(id, name) {
  return (await apiClient("patch", `/hr/policies/${id}`, { name })).data;
}

export async function deleteHrPolicy(id) {
  return (await apiClient("delete", `/hr/policies/${id}`)).data;
}

export async function uploadHrPolicyDocument(id, file) {
  const form = new FormData();
  form.append("file", file);
  return (await apiClient("post", `/hr/policies/${id}/documents`, form)).data;
}

export async function deleteHrPolicyDocument(id, documentId) {
  return (await apiClient("delete", `/hr/policies/${id}/documents/${documentId}`)).data;
}

export async function assignHrPolicy(id, userIds) {
  return (await apiClient("post", `/hr/policies/${id}/assignments`, { user_ids: userIds })).data;
}

export async function unassignHrPolicy(id, assignmentId) {
  return (await apiClient("delete", `/hr/policies/${id}/assignments/${assignmentId}`)).data;
}

export async function fetchMyHrPolicies() {
  return (await apiClient("get", "/me/hr-policies")).data;
}

export async function signMyHrPolicy(assignmentId, signerName, blob) {
  const form = new FormData();
  form.append("acknowledged", "true");
  form.append("signer_name", signerName ?? "");
  form.append("file", blob, "signature.png");
  return (await apiClient("post", `/me/hr-policies/${assignmentId}/sign`, form)).data;
}
